document.addEventListener("DOMContentLoaded", function () {
  const fullLang = document.documentElement.lang || "es";
  const lang = fullLang.split('-')[0];

  window.cartTranslations = {
    es: {
      emptyTitle: "Tu carrito está vacío",
      emptySubtitle: "¡Comienza tu rutina!",
      emptyCartLink: "https:\/\/luxmetique.com\/collections\/productos-luxmetique",
      emptyButton: "Comprar ahora",
       sliderMessages: [
    "Feeling Amazing has a Formula",
    "Cuídate desde el interior",
    "Fórmulas avaladas por la ciencia",
    "Nutricosmética avanzada"
  ],
      addText: "AÑADIR",
      recommended: "Recomendados para ti",
      cartTitle: "MI CESTA",
     freeShipping: function(amount) {
  const template = "Faltan __AMOUNT__ para obtener envío gratuito \u003cb\u003e¡Completa tu rutina!\u003c\/b\u003e!";
  return template.replace("__AMOUNT__", amount);
},

      unlockedShipping: "¡Enhorabuena! Tienes el envío gratis",
      checkoutButton: "COMPRAR"
    },
    
    en: {
      emptyTitle: "Your cart is empty!",
      emptySubtitle: "Start your routine!",
      emptyCartLink: "https:\/\/luxmetique.com\/en\/collections\/productos-luxmetique",
      emptyButton: "Shop Now",
       sliderMessages: [
    "Feeling Amazing has a Formula",
    "Take care of yourself from within",
    "Formulas backed by science",
    "Advanced Nutricosmetics"
  ],
      addText: "ADD TO CART",
      recommended: "Recommended for you",
      cartTitle: "MY CART",
      freeShipping: function(amount) {
  const template = "Missing __AMOUNT__ to get free shipping. Complete your routine!";
  return template.replace("__AMOUNT__", amount);
      },
      unlockedShipping: "Congratulations! You get free shipping",
      checkoutButton: "BUY"
    },
    pt: {
      emptyTitle: "Seu carrinho está vazio!",
      emptySubtitle: "Adicione seus produtos favoritos ao carrinho.",
      emptyCartLink: "https:\/\/luxmetique.com\/pt\/collections\/productos-luxmetique",
      emptyButton: "Comprar agora",
      sliderMessages: [
    "Feeling Amazing has a Formula",
    "Cuide de si de dentro para fora",
    "Fórmulas apoiadas pela ciência",
    "Nutricosméticos avançados"
  ],
      addText: "ADICIONAR AO CARRINHO",
      recommended: "Recomendado para você",
      cartTitle: "MINHA CESTA",
      freeShipping: function(amount) {
  const template = "Falta __AMOUNT__ para obter envio gratuito Complete a sua rotina!";
  return template.replace("__AMOUNT__", amount);
      },
      unlockedShipping: "Parabéns! Recebeu transporte gratuito",
      checkoutButton: "COMPRAR"
    }
  };

  const translations = window.cartTranslations || {};
  const t = translations[lang] || translations["es"];
  let rafPending = false;

  function updateCartTexts() {
    const cartTitle = document.getElementById('rebuy-cart-title');
    if (cartTitle) {
      cartTitle.textContent = t.cartTitle;
    }

    const checkoutButton = document.querySelector('.rebuy-cart__checkout-button span');
      if (checkoutButton) {
        checkoutButton.textContent = t.checkoutButton;
      }

    const emptyCart = document.querySelector('.rebuy-cart__flyout-empty-cart');
    if (emptyCart && !emptyCart.classList.contains('translated')) {
      emptyCart.innerHTML = `
        <p class="ql-align-center">${t.emptyTitle}</p>
        <p class="ql-align-center">${t.emptySubtitle}</p>
        <p class="ql-align-center"><a href="${t.emptyCartLink}" class="rebuy-button">${t.emptyButton}</a></p>

      `;
      emptyCart.classList.add('translated');
    }

    const addButtons = document.querySelectorAll('button.rebuy-button span');
    addButtons.forEach(span => {
      const currentText = span.textContent.trim().toUpperCase();
      if (["AÑADIR", "ADD", "ADICIONAR"].includes(currentText) && currentText !== t.addText.toUpperCase()) {
        span.textContent = t.addText;
      }
    });

    const possibleTitles = ["RECOMENDADOS PARA TI", "RECOMMENDED FOR YOU", "RECOMENDADO PARA VOCÊ"];
    const titles = document.querySelectorAll('h4.primary-title');
    titles.forEach(title => {
      const titleText = title.textContent.trim().toUpperCase();
      if (possibleTitles.includes(titleText)) {
        title.textContent = t.recommended;
      }
    });

 const sliderItems = document.querySelectorAll('.message.splide__slide');

if (sliderItems.length > 0 && Array.isArray(t.sliderMessages)) {
  sliderItems.forEach((slide, index) => {
    const msg = t.sliderMessages[index % t.sliderMessages.length];
    if (msg) slide.textContent = msg;
  });
}


const progressText = document.getElementById('rebuy-cart__progress-bar-meter-label');

if (progressText) {
  // Detectar el monto como texto tipo "€50,00"
  const match = progressText.innerText.match(/€[\d,.]+/);
  const amount = match ? match[0] : null;

  if (amount) {
    // Sobrescribimos completamente el contenido con tu plantilla
    progressText.innerHTML = t.freeShipping(amount);
  } else {
    // Si se detecta el mensaje de envío desbloqueado, también se reemplaza
    const text = progressText.innerText;
    if (
      text.includes("¡Has desbloqueado") ||
      text.includes("You've unlocked") ||
      text.includes("Você desbloqueou")
    ) {
      progressText.innerHTML = t.unlockedShipping;
    }
  }
}

    rafPending = false;
  }

  updateCartTexts();

  const globalObserver = new MutationObserver(() => {
    if (!rafPending) {
      rafPending = true;
      requestAnimationFrame(updateCartTexts);
    }
  });

  globalObserver.observe(document.body, { childList: true, subtree: true });

  const progressEl = document.getElementById('rebuy-cart__progress-bar-meter-label');
  if (progressEl) {
    const shippingObserver = new MutationObserver(() => {
      updateCartTexts();
    });

    shippingObserver.observe(progressEl, { childList: true, characterData: true, subtree: true });
  }
});
